const LoadingView: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="w-12 h-12 border-t-4 border-b-4 rounded-full animate-spin"></div>
    </div>
  );
};

export default LoadingView;
